<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">Profile and Settings</h3>
        <p class="card-subtitle">Manage your account information and password.</p>

        <!-- Tabs Section -->
        <div class="tabOptions">
          <button :class="{ active: activeTab === 'profile' }" @click="switchTab('profile')" color="primary" class="mr-2">Profile</button>
          <button :class="{ active: activeTab === 'changepassword' }" @click="switchTab('changepassword')" color="primary" class="mr-2">
            Change Password
          </button>
        </div>

        <!-- Tab Content Section -->
        <div v-if="activeTab === 'profile'">
          <vs-row>
            <vs-col>
              <div class="profile-image-container">
                <img :src="profile.image" alt="Profile Image" class="profile-image" />
                <div v-if="isEditingImage">
                  <div class="image-action-buttons">
                    <vs-button icon="cancel" @click="cancelEditingImage" class="cancel-image-button">Cancel</vs-button>
                  </div>
                </div>
                <div v-else>
                  <input ref="fileInput" type="file" style="display: none" @change="handleFileChange" />
                  <vs-button icon="edit" @click="openFilePicker" class="edit-image-button"> Edit </vs-button>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-input label="Email" v-model="profile.email" disabled />
            </vs-col>
            <vs-col>
              <vs-input label="Name" v-model="profile.name" />
            </vs-col>
            <vs-col>
              <vs-input label="Phone" v-model="profile.phone" />
            </vs-col>
            <vs-col>
              <vs-button icon="save" @click="saveProfile">Save Profile</vs-button>
            </vs-col>
          </vs-row>
        </div>
        <div v-if="activeTab === 'changepassword'">
          <vs-row>
            <!-- <vs-col>
              <vs-input label="Current Password" type="password" v-model="password.currentPassword" />
            </vs-col> -->
            <vs-col>
              <vs-input label="New Password" type="password" v-model="password.newPassword" />
            </vs-col>
            <vs-col>
              <vs-input label="Confirm Password" type="password" v-model="password.confirmPassword" @keyup.enter="savePassword" />
            </vs-col>
            <vs-col>
              <vs-button icon="save" @click="savePassword">Change Password</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "../../../common/constants";
import defaultImg from "@/assets/images/users/3.png";
import router from "../../../router";

export default {
  name: "edit-profile",
  data: () => ({
    activeTab: "profile",
    profile: {
      email: "",
      name: "",
      phone: "",
      image: defaultImg,
    },
    password: {
      newPassword: "",
      confirmPassword: "",
    },
    fileInput: null,
    isEditingImage: false,
  }),
  created() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.profile.email = user.email || "";
      this.profile.name = user.name || "";
      this.profile.phone = user.phone || "";
      this.profile.image = user.image || defaultImg;
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
    async saveProfile() {
      this.$vs.loading();
      try {
        const headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        const data = this.$data.profile;

        if (this.isEditingImage && this.fileInput) {
          const imageUrl = await this.uploadImageAd();
          if (imageUrl) data.image = imageUrl;
        }

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
          data["userId"] = JSON.parse(localStorage.user)._id;
        }

        const response = await api.put(API.UPDATE_ACCOUNT, data, { headers });

        if (response.status === 200) {
          const user = JSON.parse(localStorage.getItem("user"));
          user.name = data.name;
          user.phone = data.phone;
          user.image = data.image || user.image;
          localStorage.setItem("user", JSON.stringify(user));
          window.dispatchEvent(new Event("user-updated"));
          this.$vs.notify({
            text: "Profile Updated Successfully!",
            color: "success",
            position: "right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Profile Update Error",
          text: "Something went wrong while updating the profile!",
          color: "danger",
          position: "right",
        });
      } finally {
        this.$vs.loading.close();
        this.isEditingImage = false;
        this.fileInput = null;
      }
    },

    async savePassword() {
      try {
        if (!this.password.newPassword || !this.password.confirmPassword) {
          return this.$vs.notify({
            title: "Empty Fields",
            text: "Please fill in all fields!",
            color: "warning",
            position: "top-right",
          });
        }

        this.$vs.loading();
        const headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        const data = this.$data.password;

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
          data["userId"] = JSON.parse(localStorage.user)._id;
        }

        const response = await api.post(API.CHANGE, data, { headers });

        if (response.status === 200) {
          this.$vs.notify({
            title: "Password Changed",
            text: "Please log in again!",
            color: "warning",
            position: "right",
          });
          router.push("/logout");
        }
      } catch (error) {
        this.$vs.notify({
          title: "Password Error",
          text: "Something went wrong!",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.password = {
          newPassword: "",
          confirmPassword: "",
          currentPassword: "",
        };
      }
    },
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.$data.fileInput = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.profile.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.isEditingImage = true;
      }
    },
    cancelEditingImage() {
      this.isEditingImage = false;
      this.$data.fileInput = null;
      const user = JSON.parse(localStorage.getItem("user"));
      this.profile.image = user.image || defaultImg;
    },
    async uploadImageAd() {
      const imageType = ["image/jpeg", "image/jpg", "image/webp", "image/png"];
      const file = this.$data.fileInput;

      if (!file)
        return this.$vs.notify({
          title: "No File Selected",
          text: "Please select an image file to upload.",
          color: "warning",
          position: "top-right",
        });

      if (!imageType.includes(file.type))
        return this.$vs.notify({
          title: "Invalid File Type",
          text: "Only JPEG, JPG, WEBP, and PNG formats are supported.",
          color: "danger",
          position: "top-right",
        });

      if (file.size > 500000)
        return this.$vs.notify({
          title: "File Too Large",
          text: "File size should be less than 500KB.",
          color: "danger",
          position: "top-right",
        });

      const formData = new FormData();
      formData.append("file", file);

      this.$vs.loading();
      try {
        const response = await api.post(API.UPLOAD_IMAGE, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 200 && response.data.files && response.data.files[0].url) {
          this.$vs.notify({
            text: "Image Uploaded Successfully!",
            color: "success",
            position: "top-right",
          });
          this.isEditingImage = false;
          return response.data.files[0].url;
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (error) {
        this.$vs.notify({
          text: "Image Upload Failed!",
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style scoped>
.profile-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.profile-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #007bff;
  margin-bottom: 10px;
}

.edit-image-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.edit-image-button:hover {
  background-color: #0056b3;
}

.vs-input {
  margin-bottom: 15px;
}

.vs-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.vs-button:hover {
  background-color: #0056b3;
}

.tabOptions {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.tabOptions button {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.tabOptions button.active {
  border-bottom: 2px solid #007bff;
  color: #007bff;
}

.tabOptions button:hover {
  color: #0056b3;
}

.tabOptions button:focus {
  outline: none;
}

.file-input {
  display: none;
}

.image-action-buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.save-image-button,
.cancel-image-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.save-image-button:hover,
.cancel-image-button:hover {
  background-color: #0056b3;
}
</style>
